import { paramsToQueryKey } from '@/helpers/transformation.helpers';
import { IkpuParams, IkpusParams } from '@/api/domains/search.api';

const PREFIX = 'search';

export const SearchQueryKeys = {
  root: [PREFIX],

  getIkpusInfo: (params?: IkpusParams) => paramsToQueryKey([PREFIX, 'ikpus-info'], params),
  getIkpuInfo: (params?: IkpuParams) => paramsToQueryKey([PREFIX, 'ikpu-info'], params),
} as const;
